module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar is-fixed-top navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item is-tab",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Betygsätt")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-tab",
    attrs: {
      "to": "/list-beers"
    }
  }, [_vm._v("Provat")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-tab",
    attrs: {
      "to": "/facts"
    }
  }, [_vm._v("Fakta")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-tab is-hidden-mobile",
    attrs: {
      "to": "/add-new"
    }
  }, [_vm._v("Ny provning")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fc9aae2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc9aae2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 160
// module chunks = 1